export default [
    {
        name: 'bearMain',
        type: 'glbModel',
        path: '../../img/bp2-4-comp.glb'
    },
    {
        name: 'bearStand',
        type: 'glbModel',
        path: '../../img/bp-standing.glb'
    },
    {
        name: 'beeHive',
        type: 'glbModel',
        path: '../../img/bp2-hive-3.glb'
    },
    {
        name: 'environmentMapTexture',
        type: 'cubeTexture',
        path: [
            '../../img/px7.png',
            '../../img/nx7.png',
            '../../img/py7.png',
            '../../img/ny7.png',
            '../../img/pz7.png',
            '../../img/nz7.png'
        ]
    }
]